import { defineComponent, inject } from "vue";
import { classNames } from "../classes";
import { labeledDataListOptionsKey } from "./LabeledDataList";

export interface LabeledDataProps
{
    inline?: boolean;
}

const LabeledData = defineComponent<LabeledDataProps>({
    name: "LabeledData",
    props:
    {
        inline: { type: Boolean, default: false }
    },
    setup(props, { slots })
    {
        const listOptions = inject(labeledDataListOptionsKey, {});

        return () => (
            <div
                class={{
                    [classNames.labeledData]: true,
                    [classNames.inline]: props.inline,
                    [classNames.legendOption]: listOptions.isForLegend
                }}
            >
                {slots.default?.()}
            </div>
        );
    }
});

export default LabeledData;
